import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-card trackers-rating" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Список трекеров", -1)

import VTable from '@/components/VTable.vue'
import { useTrackersStore } from '@/stores/trackers';
import { useUiStore } from '@/stores/ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrackersList',
  setup(__props) {

const columns = {
  index: { title: "", width: 40, class: "index" },
  name: { title: "Трекер", class: "name" },
  programs: { title: "Программы" },
  rating: { title: "Оценка трекера" },
  executionCount: { title: "Execution" },
  supervisionCount: { title: "Супервизия" },
}

const trackersStore = useTrackersStore()

const uiStore = useUiStore()
const openTrackerInfo = (tracker: any) => {
  uiStore.tracker = tracker
}


return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(VTable, {
      columns: columns,
      data: Object.values(_unref(trackersStore).trackers).filter(item => !item.isDirector),
      key: "id",
      onOnitemclick: openTrackerInfo
    }, {
      index: _withCtx(({ index }) => [
        _createTextVNode(_toDisplayString(index+1), 1)
      ]),
      name: _withCtx(({ item }) => [
        _createVNode(_component_v_avatar, {
          size: "28",
          image: item.avatar,
          color: "grey-lighten-1"
        }, null, 8, ["image"]),
        _createTextVNode(" " + _toDisplayString(item.name), 1)
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})